import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { I18nProvider } from "@/i18n";
import { AuthProvider } from "@/auth";
import { CartProvider } from "@/cart";
import { ProtectedRoute } from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Experiences from "@/pages/Experiences";
import ExperienceDetail from "@/pages/ExperienceDetail";
import VacationBuilder from "@/pages/VacationBuilder";
import Checkout from "@/pages/Checkout";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Accommodations from "@/pages/Accommodations";
import AccommodationDetail from "@/pages/AccommodationDetail";
import Destination from "@/pages/Destination";
import Activate from "@/pages/Activate";
import OperatorOnboarding from "@/pages/OperatorOnboarding";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Voucher from "@/pages/Voucher";
import Tomorrow from "@/pages/Tomorrow";
import LastMinute from "@/pages/LastMinute";
import Transfers from "@/pages/Transfers";
import Restaurants from "@/pages/Restaurants";
import RestaurantDetail from "@/pages/RestaurantDetail";
import Eventi from "@/pages/Eventi";
import EventDetail from "@/pages/EventDetail";
import Guides from "@/pages/Guides";
import Concierge from "@/pages/Concierge";
import Partner from "@/pages/Partner";
import Legal from "@/pages/Legal";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Account from "@/pages/Account";
import Referral from "@/pages/Referral";
import Admin from "@/pages/Admin";
import Operator from "@/pages/Operator";
import Store from "@/pages/Store";
import Display from "@/pages/Display";
import QRValidate from "@/pages/QRValidate";
import NotFound from "@/pages/NotFound";
import { CookieConsent } from "@/components/CookieConsent";

const MANAGERS = ["super_admin", "admin", "staff"];

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/esperienze" element={<Experiences />} />
      <Route path="/esperienza/:slug" element={<ExperienceDetail />} />
      <Route path="/vacanza" element={<VacationBuilder />} />
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/shop" element={<Shop />} />
      <Route path="/shop/:slug" element={<ProductDetail />} />
      <Route path="/alloggi" element={<Accommodations />} />
      <Route path="/alloggi/:slug" element={<AccommodationDetail />} />
      <Route path="/vieste" element={<Destination />} />
      <Route path="/destinazione/:slug" element={<Destination />} />
      <Route path="/attiva/:token" element={<Activate />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/voucher/:bookingNumber" element={<Voucher />} />
      <Route path="/domani" element={<Tomorrow />} />
      <Route path="/last-minute" element={<LastMinute />} />
      <Route path="/transfer" element={<Transfers />} />
      <Route path="/dove-mangiare" element={<Restaurants />} />
      <Route path="/ristoranti/:slug" element={<RestaurantDetail />} />
      <Route path="/eventi" element={<Eventi />} />
      <Route path="/eventi/:slug" element={<EventDetail />} />
      <Route path="/guide" element={<Guides />} />
      <Route path="/concierge" element={<Concierge />} />
      <Route path="/partner" element={<Partner />} />
      <Route path="/legale/:doc" element={<Legal />} />
      <Route path="/accedi" element={<Login />} />
      <Route path="/r/:code" element={<Referral />} />
      <Route path="/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
      <Route path="/gestione" element={<ProtectedRoute roles={MANAGERS}><Admin /></ProtectedRoute>} />
      <Route path="/store" element={<ProtectedRoute roles={MANAGERS}><Store /></ProtectedRoute>} />
      <Route path="/operatore" element={<ProtectedRoute roles={["operator"]}><Operator /></ProtectedRoute>} />
      <Route path="/valida" element={<ProtectedRoute roles={["operator", ...MANAGERS]}><QRValidate /></ProtectedRoute>} />
      <Route path="/display" element={<Display />} />
      <Route path="/registrati/operatore" element={<OperatorOnboarding />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <AppRouter />
            <Toaster position="top-center" richColors />
            <CookieConsent />
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </I18nProvider>
  );
}
